// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';

@Component({
  selector: 'e-dropdown-content',
  templateUrl: './dropdown-content.component.html',
  styleUrls: ['./dropdown-content.component.scss'],
})
export class DropdownContentComponent {
  @Input() isActive: boolean;
}
